export enum SiteRoleEnum {
    OWNER = "OWNER",
    ADMIN = "ADMIN",
    USER = "USER"
}